import { SubmitContactFormCommand } from "commands/contact-submissions/SubmitContactFormCommand";
import { NewsletterRegisterCommand } from "commands/NewsletterRegisterCommand";
import { GetFaqsResult } from "results/content/GetFaqsResult";
import { GetLandingPageResult } from "results/content/GetLandingPageResult";
import { GetPageResult } from "results/content/GetPageResult";
import { GetPricingResult } from "results/content/GetPricingResult";
import { GetTeamMembersResult } from "results/content/GetTeamMembersResult";
import { GetVideosResult } from "results/content/GetVideosResult";
import { GetHomeResult } from "results/frankenstories/GetHomeResult";
import { useApiService } from "services/ApiService";

export const ContentApiService = () => {
    const { get, post } = useApiService({ controller: "/content" });

    return {
        getHome: (country: string) => get<GetHomeResult>(`/home/${country}`),
        getTerms: () => get<GetPageResult>("/terms"),
        getPrivacy: () => get<GetPageResult>("/privacy"),
        getEvents: () => get<GetPageResult>("/events"),
        getAbout: () => get<GetPageResult>("/about"),
        getSafety: () => get<GetPageResult>("/safety"),
        getPermissions: () => get<GetPageResult>("/permissions"),
        getCompetitionTerms: () => get<GetPageResult>("/competition-terms"),
        getStudentWritingResources: () => get<GetPageResult>("/student-writing-resources"),
        getTeam: () => get<GetTeamMembersResult>("/team"),
        submitContact: (command: SubmitContactFormCommand) => post("/submit-contact", command),
        registerNewsletter: (command: NewsletterRegisterCommand) => post("/newsletter-register", command),
        getFaqs: () => get<GetFaqsResult>("/faqs"),
        getFaqCategory: (name: string) => get<GetFaqsResult>(`/faqs/${name}`),
        getVideos: () => get<GetVideosResult>("/videos"),
        getPricing: () => get<GetPricingResult>("/pricing"),
        getLandingPage: (name: string) => get<GetLandingPageResult>(`/landing-page?name=${name}`),
    };
};
